import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	acceptedFormats,
	fileInput,
	fileUploadButton,
	fileUploadButtonIcon,
	displayWithFile,
} from './FileUploadField.style';

export default class FileInput extends Component {
	render() {
		return (
			<div>
				<div style={displayWithFile(this.props.hasFile)}>
					<label
						style={fileUploadButton}
						tabIndex={0}
						aria-describedby={`${this.props.hasFile ? '': 'errors__'}${this.props.questionId}`}
						className={`wds-button wds-button--secondary
							wds-button--solid wds-button--md ${this.props.disabled ? 'disabled' : ''}`}
						onKeyDown={e => {
							if ((e.key === 'Enter' || e.key === ' ') && !this.props.disabled) {
								e.preventDefault();
								document.getElementById(this.props.id).click();
							}
						}}
					>
						<i
							className="nc-icon-mini arrows-2_square-upload"
							style={fileUploadButtonIcon}
						>
						</i>
						{
							this.props.first ?
								gettext('Upload a file') :
								gettext('Upload another file')
						}
						<input
							id={this.props.id}
							name={this.props.id}
							type="file"
							disabled={this.props.disabled}
							style={fileInput}
							onChange={this.props.handleFileInputChange}
							accept={this.props.limitFileFormat ? this.props.fileFormats : ''}
						/>
					</label>
					{
						this.props.limitFileFormat
						&& (
							<div style={acceptedFormats}>
								<strong>{gettext('Accepted formats')}:</strong> {this.props.fileFormats}
							</div>
						)
					}
				</div>
			</div>
		);
	}
}

FileInput.propTypes = {
	id: PropTypes.string.isRequired,
	questionId: PropTypes.string,
	index: PropTypes.number.isRequired,
	disabled: PropTypes.bool.isRequired,
	handleFileInputChange: PropTypes.func.isRequired,
	limitFileFormat: PropTypes.bool.isRequired,
	fileFormats: PropTypes.string,
	hasFile: PropTypes.bool
};
